import { render, staticRenderFns } from "./CalculationSchemes.vue?vue&type=template&id=24211bb8&scoped=true"
import script from "./CalculationSchemes.vue?vue&type=script&lang=ts"
export * from "./CalculationSchemes.vue?vue&type=script&lang=ts"
import style0 from "./CalculationSchemes.vue?vue&type=style&index=0&id=24211bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24211bb8",
  null
  
)

export default component.exports